var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-youtube"},[_c('iframe',{staticClass:"a-youtube__iframe",attrs:{"type":"text/html","src":`https://www.youtube.com/embed/${_vm.youTubeId}`,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }